import {
  CreateDependenteDto,
  GetDependenteDto,
  UpdateDependenteDto,
} from '../shared/dtos/Dependente.dto';
// src/services/AuthService.ts
import api from './api';

class DependenteService {
  async createDependente(data: CreateDependenteDto): Promise<{status:boolean, message:string, dependente: GetDependenteDto}> {

    return api
      .post('/dependente/cadastrar', data)
      .then((response) => {
       
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        console.error(
          'Erro ao registrar:',
          error.response ? error.response.data : error.message
        );
        return Promise.reject(error);
      });
  }

  async getAllDependentesByContribuinte(
    idContribiunte: number
  ): Promise<GetDependenteDto[]> {
    return api
      .get('/dependente/find-by-contribuinte/' + idContribiunte)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        console.error(
          'Erro ao pegar dependentes',
          error.response ? error.response.data : error.message
        );
        return Promise.reject(error);
      });
  }

  async searchDependente(
    query: { cpfCin?: string; nome?: string },
    idContribuinte: number
  ): Promise<any> {

    return api
      .get('/dependente/search', {
        params: { cpfCin: query.cpfCin, nome: query.nome, idContribuinte },
      })
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        console.error(
          'Erro ao buscar dependente:',
          error.response ? error.response.data : error.message
        );
        return Promise.reject(error);
      });
  }

  async updateDependente(id: number, data: UpdateDependenteDto) {
    return api
      .patch(`/dependente/update/${id}`, data)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        console.error(
          'Erro ao atualizar dependente:',
          error.response ? error.response.data : error.message
        );
        return Promise.reject(error);
      });
  }

  async deleteDependente(id: number) {
    return api
      .delete(`/dependente/delete/${id}`)
      .then((response) => {
        return Promise.resolve(response.data); // Retorna o sucesso
      })
      .catch((error) => {
        console.error(
          'Erro ao remover dependente:',
          error.response ? error.response.data : error.message
        );
        return Promise.reject(error); // Retorna erro caso falhe
      });
  }

  async searchCpf(
    cpfToSearch: string
  ): Promise<{ status: boolean; message: string }> {
    try {
      const response = await api.get(`/dependente/search-cpf`, {
        params: { cpfToSearch: cpfToSearch },
      });
      return response.data as { status: boolean; message: string };
    } catch (error: any) {
      console.error(`Erro ao buscar CPF`, error);
      throw new Error('Não foi possível buscar o CPF informado.'); // Retorna um erro mais amigável
    }
  }
}

const dependenteService = new DependenteService();
export default dependenteService;
